import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './radio.css';
import Radio from './radio.js';
import { htmlDecode, slugify } from '../helpers.js';

var RadioGroup = function (_Component) {
	_inherits(RadioGroup, _Component);

	function RadioGroup() {
		_classCallCheck(this, RadioGroup);

		return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this));
	}

	_createClass(RadioGroup, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    options = _props.options,
			    title = _props.title,
			    step_index = _props.step_index,
			    wkSelectedOptions = _props.wkSelectedOptions,
			    handleChange = _props.handleChange,
			    shopify_product_title = _props.shopify_product_title,
			    selectedOptions = _props.selectedOptions,
			    itemAction = _props.itemAction;


			var name = slugify(title + ' ' + step_index);
			return React.createElement(
				'div',
				{ className: 'RadioGroup', tabIndex: '0' },
				React.createElement(
					'p',
					{ className: 'RadioGroup-title' },
					title
				),
				options.map(function (option, index) {
					var checked = void 0;
					var id = slugify(title + ' ' + option + ' ' + step_index);
					if (wkSelectedOptions) {
						var this_selection = wkSelectedOptions.filter(function (s_option) {
							return htmlDecode(s_option.name.trim()) == title;
						})[0];

						checked = this_selection ? htmlDecode(this_selection.value.trim()) == option : false;
					}

					if (selectedOptions) {
						checked = option == selectedOptions[title] ? true : false;
					}

					return React.createElement(Radio, {
						key: 'radio-' + index,
						id: id,
						checked: checked,
						label: option,
						name: name,
						itemAction: itemAction,
						shopify_product_title: shopify_product_title,
						title: title });
				})
			);
		}
	}]);

	return RadioGroup;
}(Component);

export default RadioGroup;